import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserManager from '@pages/manage/account/userManager';
import TeamManager from '@pages/manage/account/teamManager';
import AlertManager from '@pages/manage/account/alertManager';
import LoginMonitor from '@pages/manage/account/loginMonitor';

const AccountRoutes: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/userManager" element={<UserManager />} />
        <Route path="/teamManager" element={<TeamManager />} />
        <Route path="/alertManager" element={<AlertManager />} />
        <Route path="/loginMonitor" element={<LoginMonitor />} />
      </Routes>
    </>
  );
};

export default AccountRoutes;
